
app.directive('showErrors', ['portalHelper', function (portalHelper) {
  return {
    scope: {
      errors: '='
    },
    templateUrl: portalHelper.getUrlRev('html_templates/directives/show_errors.162f5e3d.html')
  };
}]);
